import script from "./SchnellVergleich.vue?vue&type=script&setup=true&lang=js"
export * from "./SchnellVergleich.vue?vue&type=script&setup=true&lang=js"

import "./SchnellVergleich.vue?vue&type=style&index=0&id=bac6d2de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bac6d2de"]])

export default __exports__